import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["size"];
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
// DO NOT EDIT IT MANUALLY

import * as React from 'react';
import { jsx as _jsx } from "react/jsx-runtime";
var SvgSuperset = /*#__PURE__*/React.forwardRef(function (_ref, ref) {
  var _ref$size = _ref.size,
    size = _ref$size === void 0 ? 24 : _ref$size,
    props = _objectWithoutProperties(_ref, _excluded);
  props.width = undefined;
  props.height = undefined;
  var testId = 'icon-superset';
  var style = {};
  var isCustomSize = typeof size === 'number';
  if (isCustomSize) {
    style.width = size + 'px';
    style.height = size + 'px';
    if (!props.style) props.style = {};
    props.style.width = size + 'px';
    props.style.height = size + 'px';
  }
  return /*#__PURE__*/_jsx("svg", _objectSpread(_objectSpread({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "currentColor",
    viewBox: "0 0 24 24",
    "data-test-id": testId,
    ref: ref
  }, props), {}, {
    children: /*#__PURE__*/_jsx("path", {
      fill: "inherit",
      fillRule: "evenodd",
      d: "M6.634 7.282c-1.977.176-3.598 1.444-4.165 3.258-.158.506-.208.873-.205 1.5.007 1.194.359 2.163 1.104 3.038.81.952 1.882 1.499 3.231 1.649 1.18.131 2.493-.284 3.601-1.14 1.024-.791 1.593-1.501 2.781-3.474.944-1.57 1.709-2.418 2.622-2.908.865-.465 1.777-.533 2.692-.201.908.329 1.588 1.05 1.833 1.944.071.258.086.422.086.952 0 .759-.066 1.058-.362 1.66-.158.32-.245.437-.55.741-.413.412-.721.595-1.271.755-1.126.326-2.475.198-3.328-.316a1.7 1.7 0 0 0-.263-.14c-.024 0-.655.786-.869 1.083-.042.058-.018.088.18.227.858.599 2.194.917 3.409.811 1.455-.128 2.404-.529 3.23-1.367.376-.381.591-.687.828-1.174a5.13 5.13 0 0 0 .274-3.88c-.204-.632-.479-1.085-.961-1.585-.683-.708-1.538-1.159-2.577-1.359-.34-.065-1.222-.065-1.594.001-1.242.219-2.456.999-3.458 2.22-.44.537-.76 1.007-1.321 1.94-.257.428-.581.95-.72 1.16-.694 1.05-1.547 1.833-2.44 2.244-.553.254-.767.299-1.421.296-.513-.002-.621-.015-.939-.112-.684-.209-1.215-.568-1.637-1.107s-.612-1.059-.651-1.786c-.055-.994.241-1.815.893-2.481.662-.676 1.57-1.007 2.634-.958a3.77 3.77 0 0 1 1.872.557c.157.093.287.146.306.126.089-.096.802-1.138.802-1.173 0-.061-.639-.425-1.064-.607a5.2 5.2 0 0 0-1.604-.394 8 8 0 0 0-.552-.036z"
    })
  }));
});
export default SvgSuperset;